/** The "this person's email is undeliverable" banner for detail pages.
 *
 * One shared component (the InviteStateCell precedent) so the student
 * and HR pages cannot word the same fact differently, and so the link
 * into the ledger page — where the evidence and the release action
 * live — is never forgotten by one of them.
 *
 * Renders nothing when the person has no active suppression; callers
 * pass the detail response's `emailUndeliverable` straight through.
 */
import { Link } from 'react-router-dom'
import { Notice } from '@speaking-coach/ui'
import { formatWhen, reasonProse } from './format'
import type { EmailUndeliverable } from './types'

export function UndeliverableNotice({
  value,
}: {
  value: EmailUndeliverable | null | undefined
}): JSX.Element | null {
  if (value === null || value === undefined) return null
  return (
    <Notice variant="warning">
      Email undeliverable since {formatWhen(value.since)} —{' '}
      {reasonProse(value.reason).toLowerCase()}. Invitations and other mail
      to this person are skipped.{' '}
      <Link
        to={`/admin/email-suppressions/${value.emailHash}`}
        className="underline"
      >
        View bounce history and release
      </Link>
    </Notice>
  )
}
